/**
 * Создание объекта с дефолтным значением, возращаемым при обращении к несуществующему ключу
 */

export const createObjectWithDefault = <T extends object>(obj: T, defaultValue: any) => {
  const defaultHandler: ProxyHandler<T> = {
    get(target, name) {
      return target.hasOwnProperty(name) ? target[name] : defaultValue;
    },
  };

  return new Proxy(obj, defaultHandler);
};
